import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import TwSlider from '../../../../../TwSlider';

const duration = require('dayjs/plugin/duration');

dayjs.extend(duration);
dayjs.extend(dayjsPluginUTC);

const LayoverSlider = ({ layover, onLayoverChange, layoverMin, layoverMax, name }) => {
  const [displayLayover, setDisplayLayover] = useState(layover);
  const formatSliderValue = (val) => {
    const layoverDuration = dayjs.duration(val, 'minutes');
    if (layoverDuration.hours() === 0) {
      return `${layoverDuration.minutes()} min`;
    }
    if (layoverDuration.minutes() === 0) {
      return `${layoverDuration.hours()} hr`;
    }
    return `${layoverDuration.hours()} hr ${layoverDuration.minutes()} min`;
  };

  const handleLayoverChange = (event, newValue) => {
    setDisplayLayover(newValue);
  };
  return (
    <>
      <div className="grid grid-cols-3 items-center mb-2">
        <div className="text-sm text-black font-bold">{name || 'Layover Duration'}</div>
        <div className="col-span-2 text-right ml-4 text-xs text-gray-700">
          {`${formatSliderValue(displayLayover[0])} - ${formatSliderValue(displayLayover[1])}`}
        </div>
      </div>
      <TwSlider
        value={displayLayover}
        onChangeCommitted={onLayoverChange}
        onChange={handleLayoverChange}
        min={layoverMin}
        max={layoverMax}
        step={5}
      />
    </>
  );
};

LayoverSlider.propTypes = {
  layover: PropTypes.arrayOf(PropTypes.number).isRequired,
  layoverMin: PropTypes.number.isRequired,
  layoverMax: PropTypes.number.isRequired,
  onLayoverChange: PropTypes.func.isRequired,
  name: PropTypes.string,
};

LayoverSlider.defaultProps = {
  name: '',
};

export default memo(LayoverSlider);
